import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TicketCreate as TicketCreate23 } from 'projects/flow-gui-access/views/2.3/ticket'
import { TicketCreate as TicketCreate24 } from 'projects/flow-gui-access/views/2.4/ticket'

class TicketCreate extends Component {
  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'tickets' && endpoint.version === '2.4').length !== 0) {
      return <TicketCreate24 {...this.props} />
    } else if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'tickets' && endpoint.version === '2.3').length !== 0) {
      return <TicketCreate23 {...this.props} />
    } else return false
  }
}

export default connect(state => state)(TicketCreate)



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/middlewares/ticket/create.js